import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import StatusContext from '../../../contexts/StatusContext'
import StocksContext from '../../../contexts/StocksContext'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MarkdownResponseDisplay from '../markdown/MarkdownResponseDisplay';


export const DialogPreview = () => {

  const {
    changeLanguageEnglish,
} = React.useContext(StatusContext);

const {
  preview,
  showPreviewDialog,
  setShowPreviewDialog,
 
} = React.useContext(StocksContext);


const handleClose = (event, reason) => {

  setShowPreviewDialog(false);
};

  return (
   
    <React.Fragment>
   
        <Dialog
          open={showPreviewDialog}
          onClose={handleClose}
         
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
              
            },
          }}
        >

        <DialogTitle className="dialogTitleModifyTest" style = {{fontSize:'16px', color:'maroon'}}>{changeLanguageEnglish('templates', 'preview')}</DialogTitle>

      
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
        <CloseIcon />
      </IconButton>

        <DialogContent dividers>
         
              <div>
                <MarkdownResponseDisplay text={preview} />
              </div>
          
        </DialogContent>
      </Dialog>
    </React.Fragment>
    
  );
  
}